// ============================================================
// CASSA: da dove esce lo scontrino e quanto bisogna avvicinarsi.
//
// Il POS è cotto dentro la mesh del negozio (mainModel), quindi a
// runtime non esiste un nodo da cui leggere la posizione: questi valori
// si tarano a vista con gli slider Leva in ?debug, come si è fatto per
// scaffali e tabellone pubblicitario.
//
// UNITÀ: il personaggio è alto ~3.2 unità, quindi 1 unità ≈ 0.55 m.
// Il piano del bancone sta a y ≈ 1.98 (vedi i collisori in
// Experience.jsx), il POS ci sta sopra: la bocchetta è poco più su.
// ============================================================
export const cfgCassa = {
  // Bocchetta della stampante, in coordinate mondo. Il POS è cotto
  // dentro la mesh del negozio: la sua posizione non si legge da
  // nessuna parte, si è ricavata mirandolo in gioco (window.__mira in
  // ?debug) e occupa x 1.95..2.50, y 2.15..2.38, z -3.85..-3.40, con la
  // faccia superiore inclinata. Questi valori sono poi stati rifiniti a
  // vista con gli slider, stando davanti al bancone.
  x: 2.41,
  y: 2.35,
  z: -3.80,
  // ORIENTAMENTO della bocchetta (gradi): da che parte esce la carta.
  // Il contorno NON segue più questi — ha i suoi, più sotto.
  //   giro    = attorno alla verticale (imbardata)
  //   inclina = muso su/giù (beccheggio)
  //   rolla   = sbandata laterale
  giro: 116,
  inclina: -34,
  rolla: 0,
  // Inclinazione della carta rispetto alla bocchetta (gradi): 0 = cade
  // a piombo, 90 = esce di piatto.
  piega: 83,
  // larghezza della carta in unità di mondo (0.18 ≈ 10 cm reali)
  larghezza: 0.18,
  // entro questa distanza si può pagare
  raggio: 2.6,

  // Filo bianco attorno al POS: serve a far capire che quel blocco è
  // interattivo. Il POS è cotto dentro la mesh del negozio, quindi non
  // si può contornare la sua sagoma — si contorna la FACCIA SUPERIORE
  // con un rettangolo arrotondato, un solo piano appoggiato sopra.
  //
  // POSIZIONE ASSOLUTA, non uno scostamento dalla bocchetta: erano
  // scostamenti, e spostando la carta si trascinava dietro anche il
  // contorno. Sono due oggetti diversi e ora hanno coordinate proprie.
  // Misure di partenza prese dagli estremi del POS ricavati col raggio
  // (x 1.95..2.50, z -3.85..-3.40, faccia alta a y 2.38): il rettangolo
  // vale quanto quella impronta e sta appoggiato sopra.
  // ritoccati dall'utente coi cursori (2026-09-11, poi 2026-09-15)
  // 2026-09-16: lo spostamento di 2 unita' a sinistra (bordoZ -5.70) e' stato
  // ANNULLATO — l'utente ha poi tarato il contorno coi cursori e ha mandato i
  // valori buoni: sono questi. NB: il terzo cursore mostrava 3.72 ma la
  // posizione e' NEGATIVA (il bancone sta a z negative), quindi -3.72.
  bordoX: 2.20,
  bordoY: 2.29,
  bordoZ: -3.72,
  boxL: 0.52,          // larghezza del rettangolo
  boxP: 0.64,          // profondità del rettangolo
  bordoRaggio: 0.09,   // raggio degli angoli
  bordoSpess: 0.02,    // spessore del filo, in unità di mondo
  // Un piano ha DUE pendenze, non una: bordoInclina lo fa pendere avanti
  // o indietro, bordoRolla lo fa pendere di lato. Con la sola prima si
  // poteva inclinare in una direzione sola, e per l'altra bisognava
  // girare il rettangolo di 90 gradi — scambiando larghezza e profondità.
  bordoInclina: -21,   // pendenza avanti/indietro (gradi)
  bordoRolla: 2,       // pendenza laterale (gradi)
  bordoGiro: 117,      // rotazione sul proprio piano (gradi)

  // Ingrandimento finale: a stampa finita lo scontrino viene portato
  // davanti alla visuale, per poterlo leggere.
  zoomDist: 0.45, // quanto lontano dall'occhio
  zoomSu: 0.06,   // quanto sopra il centro dello schermo

  // TARATURA: tiene scontrino e contorno sempre in vista, anche fermi e
  // a carrello vuoto. Senza, la carta è invisibile finché non si stampa
  // e si sposterebbe alla cieca. Solo in ?debug, spento di default.
  mostraSempre: false,
}

// In ?debug la configurazione è raggiungibile da console (window.__cassa)
// e si può anche SCRIVERE: gli slider Leva riscrivono questo oggetto solo
// quando uno di loro si muove davvero (vedi Cassa.jsx), quindi un valore
// assegnato a mano — o da uno script di taratura — resta.
// I valori trovati vanno poi riportati qui sopra: è l'unico posto che li
// rende permanenti, Leva riparte da questi a ogni ricaricamento.
if (typeof window !== 'undefined' &&
    new URLSearchParams(window.location.search).has('debug')) {
  window.__cassa = cfgCassa
}
